export default __webpack_public_path__ + "static/media/bg5.7d7c2284.png";